import { Card, Table, Badge } from 'react-bootstrap';
import { formatCurrency } from '../../utils/formatters';
import { getFundTypeLabel } from '../../utils/fundTypeUtils';

const CurrentBenefitsPanel = ({ state, fundType, currentEnergyDiscount, numGrants, totalGrantsApplied }) => {
  const fundTypeLabel = getFundTypeLabel(fundType);
  return (
    <div className="text-muted">
      <div><strong>Current Benefits</strong></div>
      <hr />
      <div><strong>Active Energy Discount: </strong>
        {currentEnergyDiscount != null ? (
          <Badge bg="success">{currentEnergyDiscount}%</Badge>
        ) : (
          <span className="text-muted">None</span>
        )}
      </div>

      {numGrants != null && (
        <div><strong>{fundTypeLabel} Grants: </strong>{numGrants || 0}</div>
      )}
      {totalGrantsApplied != null && (
        <div><strong>{fundTypeLabel} Total Applied: </strong>{formatCurrency(totalGrantsApplied)}</div>
      )}
    </div>
  );
};

export default CurrentBenefitsPanel;